import { UPGRADE_MODAL_DISMISSED_COOKIE } from '@shared/constants/StorageValues';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useAlertsStore } from './state/AlertsContainer';
import { useAuthStore } from './state/AuthContainer';
import { useCurrentUserStore } from './state/CurrentUserContainer';
import { useDeviceStore } from './state/DeviceContainer';
import { useGlobalCustomControlsStore } from './state/GlobalCustomControlsContainer';
import { useProfilesStore } from './state/ProfilesContainer';
import { usePublicProfilesStore } from './state/PublicProfilesContainer';
import { useCurrentDeviceStore } from '@shared/hooks/state/CurrentDeviceContainer';

export default function useSignout() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [isShowingSignoutConfirmation, setIsShowingSignoutConfirmation] = useState<boolean>(false);

    const hideSignoutConfirmation = useCallback(() => {
        setIsShowingSignoutConfirmation(false);
    }, []);

    const showSignoutConfirmation = useCallback(() => {
        setIsShowingSignoutConfirmation(true);
    }, []);

    const clearAndReload = useCallback(() => {
        // Perform all necessary cleanup operations
        useAuthStore.getState().logout();
        useDeviceStore.getState().clearDevices();
        useCurrentDeviceStore.getState().clearAll();
        useProfilesStore.getState().clearProfiles();
        usePublicProfilesStore.getState().clearProfiles();
        useCurrentUserStore.getState().clearCurrentUser();
        useGlobalCustomControlsStore.getState().clear();
        // Clear upgrade modal dismissal so it shows again on next login
        localStorage.removeItem(UPGRADE_MODAL_DISMISSED_COOKIE);
        navigate('../login');
        window.location.reload(); // Reload the page to ensure all changes take effect
    }, []);

    const signout = async () => {
        console.log('signout');
        // remove everything from local storage, navigate to home page, refresh page
        // delete virtual device then clear
        useAuthStore.getState().handleIsLoading(true);
        hideSignoutConfirmation();
        const virtualDeviceId = useDeviceStore.getState().virtualDeviceId;
        if (virtualDeviceId) {
            try {
                const result = await useDeviceStore.getState().disableDevice(virtualDeviceId);
                if (result?.resultType != 'Ok') {
                    useAlertsStore.getState().showError(t('common:device.error.deleteLong'));
                }
            } catch (error) {
                useAlertsStore.getState().showError(t('common:device.error.deleteLong'));
            }
        }
        clearAndReload();

        useAuthStore.getState().handleIsLoading(false);
    };
    return {
        signout,
        isSignOutConfirmationVisible: isShowingSignoutConfirmation,
        showSignoutConfirmation,
        hideSignoutConfirmation,
        clearAndReload,
    };
}
